import { useStore } from "../../app/store.ts";
import { SurfaceAlignmentGrid } from "../SurfaceAlignmentGrid.tsx";
import { SurfaceSelectionHighlight } from "../SurfaceSelectionHighlight.tsx";
import { viewportSupportsSceneInteraction } from "../viewportInteractionPolicy.ts";
import { CameraBookmarkGizmos } from "./CameraBookmarkGizmos.tsx";
import { CursorGizmo } from "./CursorGizmo.tsx";
import { OperatorGizmo } from "./OperatorGizmo.tsx";
import { ProportionalInfluenceRing } from "./ProportionalInfluenceRing.tsx";
import { SurfaceFootprintGizmo } from "./SurfaceFootprintGizmo.tsx";
import { SurfaceInsetGizmo } from "./SurfaceInsetGizmo.tsx";
import { SurfacePolyGizmo } from "./SurfacePolyGizmo.tsx";
import { TransformGizmo } from "./TransformGizmo.tsx";

export function SceneGizmoLayer() {
  const showSceneInteraction = useStore((s) =>
    viewportSupportsSceneInteraction(s.workspaceMode),
  );

  return (
    <>
      {showSceneInteraction && <CursorGizmo />}
      <TransformGizmo />
      <ProportionalInfluenceRing />
      <OperatorGizmo />
      <SurfaceSelectionHighlight />
      <SurfaceFootprintGizmo kind="box" />
      <SurfaceFootprintGizmo kind="cylinder" />
      <SurfaceAlignmentGrid />
      <SurfacePolyGizmo />
      <SurfaceInsetGizmo />
      {showSceneInteraction && <CameraBookmarkGizmos />}
    </>
  );
}
